export default __webpack_public_path__ + "static/media/insta.7b486326.svg";